export const parseFloatField = (value: string) => {
  let parsedFloat = value;

  if (!/^\d*(\.\d{0,18})?$/.test(value)) {
    if (value[0].startsWith('.')) {
      parsedFloat = '.' + value.replace(/\D/g, '');
    } else {
      const dotIndex = value.indexOf('.');
      if (dotIndex === -1) {
        parsedFloat = value.replace(/\D/g, '');
      } else {
        parsedFloat =
          value.slice(0, dotIndex).replace(/\D/g, '') +
          '.' +
          value.slice(dotIndex + 1).replace(/\D/g, '');
      }
    }
  }

  return isNaN(Number(parsedFloat)) ? undefined : parsedFloat;
};

export const formatFloatField = (value?: number) => {
  return value === undefined
    ? ''
    : value.toLocaleString('en-us', {
        maximumFractionDigits: 18,
        useGrouping: false,
      });
};

export const parseIntField = (value: string) => {
  let parsedInt = value;

  if (!/^\d*?$/.test(value)) {
    parsedInt = value.replace(/\D/g, '');
  }

  return isNaN(Number(parsedInt)) ? undefined : parsedInt;
};

export const formatIntField = (value?: number) => {
  return value === undefined ? '' : value.toString();
};
